export const summary = (l10n={}, it = {}, enchant=0, defaultThumb = '') => {

    let enchantList = '';
    for (let i = 0; i < it.enchantBonusList?.length; i++) {
        enchantList += `<li data-detailshow="item_${it.id}_${i}" data-enchant="${i}">+${i}</li>`;
    }

    return `
    <section class="summary">
        <img class="thumb" src="${it.image}" onerror="this.src='${defaultThumb}';">
        ${!it.enchantable?``:`
        <div class="ui-dropdown-wrap inchant">
            <div class="ui-dropdown ui-dropdown-community">
                <div class="select">
                    <span class="selectedCategory" data-value="">+${enchant}</span>
                </div>
                <div class="option">
                    <div class="option-menu" style="width: 100%;">
                        <ul class="option-list">${enchantList}</ul>
                    </div>
                </div>
            </div>
        </div>
        `}
        <div class="spec">
            <strong class="name" data-itemgrade="${it.gradeId}">${it.name}${it.tradable?``:` <span class="tradable" title="${l10n['item.bound']}"></span> `}</strong>
            <div class="ability">
                <span class="category-${it.itemFilterTypeId}" title="${it.itemFilterType}">${l10n['item.detailIcon.category']}</span>
                <span class="storable${it.storable?' is-active':''}" title="${l10n['item.detailIcon.storage']}">${l10n['item.detailIcon.storage']}</span>
                <span class="droppable${it.droppable?' is-active':''}" title="${l10n['item.detailIcon.dropWhenDead']}"">${l10n['item.detailIcon.dropWhenDead']}"</span>
                <span class="tradeable${it.tradable?' is-active':''}" title="${l10n['item.detailIcon.trade']}">${l10n['item.detailIcon.trade']}</span>
                <span class="enchantable${it.enchantable?' is-active':''}" title="${l10n['item.detailIcon.safeUpgradeLevel']}">${l10n['item.detailIcon.safeUpgradeLevel']}</span>
                ${!it.enchantable?``:`<strong class="safe_enchant_level">${it.safeEnchantLevel}</strong>`}
            </div>
        </div>
        <button class="btn-favorite${it.favorite?' is-active':''}" data-info="items_${it.id}"><i></i> Favorite</button>
    </section>`;
}
